import React from 'react'

/** @param {{ detail: import('../../help/help-index.js').HelpSidebarDetail }} props */
const HelpDetailContent = ({ detail }) => (
  <div className="help-detail">
    {detail.sections.map((section) => (
      <section key={section.title} className="help-detail__section">
        <h5 className="help-detail__title">{section.title}</h5>
        {section.intro && <p className="help-detail__intro">{section.intro}</p>}
        {section.bullets?.length > 0 && (
          <ul className="help-detail__bullets">
            {section.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        )}
        {section.paragraphs?.map((paragraph) => (
          <p key={paragraph} className="help-detail__paragraph">
            {paragraph}
          </p>
        ))}
        {section.fields?.length > 0 && (
          <dl className="help-detail__fields">
            {section.fields.map((field) => (
              <div key={field.label} className="help-detail__field">
                <dt>{field.label}</dt>
                <dd>{field.description}</dd>
              </div>
            ))}
          </dl>
        )}
      </section>
    ))}
  </div>
)

export default HelpDetailContent
